import React, { useCallback, useEffect, useState } from 'react'
import { Button, Container, Grid, Typography, generateUtilityClasses } from '@mui/material'
import { styled } from '@mui/system'
import AddIcon from '@mui/icons-material/Add'
import { useSelector } from 'react-redux'
import { getStates } from '../../../../../../redux/slices/userDropdownSlice'
import { useFormState } from 'react-final-form'
import { debounce } from 'lodash'
import DropdownFieldSearch from '../../../../../../ui/DropdownFieldSearch'
import TextField from '../../../../../../ui/TextField'
import CheckboxField from '../../../../../../ui/CheckboxField'

const classes = generateUtilityClasses('Container', ['root', 'titleWrap', 'searchWrap', 'searchBtn'])

const StyledFormWrap = styled(Container)(({ theme }) => ({
  [`&.${classes.root}`]: {
    padding: theme.spacing(1, 1, 1, 1),
    margin: 0,
    display: 'flex',
    backgroundColor: theme.palette.background.main,
    width: '100%',
    maxWidth: 'unset',
    position: 'sticky',
    top: 0,
    zIndex: 10,
    alignItems: 'center',
  },
  [`& .${classes.titleWrap}`]: {
    margin: theme.spacing(2, 2, 1, 2),
  },
  [`& .${classes.searchWrap}`]: {
    width: theme.spacing(20),
    margin: theme.spacing(0, 4, 0, 0),
  },

  [`& .${classes.searchBtn}`]: {
    margin: theme.spacing(0, 2, 0, 'auto'),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-evenly',
    minWidth: '90px',
    padding: '10px',
  },
}))

interface Props {
  submit: (...args: any) => any
  handleOpenModal: () => void
}

const FormsPacksSearchBlock = ({ submit, handleOpenModal }: Props) => {
  const { values } = useFormState()
  const states = useSelector(getStates)

  const updateWithDebounce = useCallback(
    debounce(() => {
      submit(values)
    }, 500),
    [],
  )

  useEffect(() => {
    // search with debounce
    if (values?.SearchField || values?.SearchField !== '') {
      updateWithDebounce()
    }
  }, [values?.SearchField])

  useEffect(() => {
    // search with debounce
    if (values?.State || values?.State !== '') {
      updateWithDebounce()
    }
  }, [values?.State])

  useEffect(() => {
    // search with debounce
    if (values?.IncludeInactive || !values?.IncludeInactive) {
      updateWithDebounce()
    }
  }, [values?.IncludeInactive])

  useEffect(() => {
    if (values?.SearchField || values?.State || values?.IncludeInactive) {
      updateWithDebounce()
    }
  }, [values?.SearchField, values?.State || values?.IncludeInactive])

  return (
    <>
      <Grid container spacing={2} alignItems={'center'} px={3} pt={3}>
        {/* <Grid className={classes.titleWrap}>
          <Typography variant='h3'>Form Packs</Typography>
        </Grid> */}
        <Grid item xs={3}>
          <DropdownFieldSearch name='State' label='State' options={states} optionKey='State' optionValue='State' autoComplete='off' />
        </Grid>

        <Grid item xs={3}>
          <TextField name='SearchField' placeholder='Search' fullWidth />
        </Grid>

        <Grid item xs={3}>
          <CheckboxField name='IncludeInactive' label='Include Inactive' />
        </Grid>
        {/* 
        <Button onClick={() => handleOpenModal && handleOpenModal()} className={classes.searchBtn} variant='contained' startIcon={<AddIcon />}>
          Add new
        </Button> */}
      </Grid>
    </>
  )
}

export default FormsPacksSearchBlock
